import { render, staticRenderFns } from "./partners_with_franchise_relations.vue?vue&type=template&id=2c861789&scoped=true&"
import script from "./partners_with_franchise_relations.vue?vue&type=script&lang=js&"
export * from "./partners_with_franchise_relations.vue?vue&type=script&lang=js&"
import style0 from "./partners_with_franchise_relations.vue?vue&type=style&index=0&id=2c861789&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c861789",
  null
  
)

export default component.exports